import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { getPublicMenuPath } from '@/lib/tenant/getPublicMenuPath';
import { DEMO_PUBLIC_BRAND } from '@/lib/demo/demoBusiness';
import CustomerLanguageSwitcher from '@/components/menu/CustomerLanguageSwitcher';

export default function CheckoutPageHeader({ routeBid, isDemoCheckout }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="sticky top-0 z-40 border-b bg-background">
      <div className="max-w-4xl mx-auto px-4 py-4 flex flex-wrap items-center gap-2">
        <Button
          variant="ghost"
          onClick={() => navigate(getPublicMenuPath(routeBid, 'catalog'))}
          data-testid="checkout-back-catalog"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          {t('checkout.continueMenu')}
        </Button>
        <Button
          variant="ghost"
          onClick={() => navigate(getPublicMenuPath(routeBid, 'home'))}
          data-testid="checkout-back-home"
        >
          {t('checkout.backHome')}
        </Button>
        <div className="ml-auto flex items-center gap-2">
          <CustomerLanguageSwitcher compact />
          {isDemoCheckout ? (
            <Badge
              variant="outline"
              className="text-[10px] font-medium tracking-wide border-violet-300/50 bg-violet-500/10 text-foreground"
            >
              {DEMO_PUBLIC_BRAND.badge}
            </Badge>
          ) : null}
        </div>
      </div>
    </div>
  );
}
